import {
  getPanel,
  goToProject,
  selectProjectUser
} from "./selectProjectUserOrPanel";
import { DASHBOARD_MANAGER, DASHBOARD_PETTY_CASHIER } from "../constants/urls";
import Store from "../configureStore";
import { PROJECT_USER_ROLES } from "../constants/projectUser";
import { CUSTODIAN_PANEL } from "../constants/panelTypes";

export const changePanel = () => {
  const init = Store.getState().Init.data;
  let loginUser = Store.getState().User.data;
  const currentPanel = getPanel();
  let destinationLink;
  if (currentPanel === CUSTODIAN_PANEL) {
    destinationLink = DASHBOARD_MANAGER;
  } else {
    destinationLink = DASHBOARD_PETTY_CASHIER;
  }
  if (destinationLink === DASHBOARD_PETTY_CASHIER) {
    selectProjectUser(init.project);
  } else {
    const targetProjectUsers = init.project.project_users.filter(
      projectUser =>
        projectUser.user_id === loginUser.id &&
        projectUser.user_type !== PROJECT_USER_ROLES.CUSTODIAN
    );
    if (targetProjectUsers.length > 0) {
      goToProject(targetProjectUsers[0], init.project);
    }
  }
};

export const getTargetPanelData = () => {
  const currentPanel = getPanel();
  let targetPanelData = { title: "", accesses: [] };

  if (currentPanel === CUSTODIAN_PANEL) {
    targetPanelData = {
      title: "ورود به پنل مدیریت",
      accesses: [
        PROJECT_USER_ROLES.OWNER,
        PROJECT_USER_ROLES.ADMIN,
        PROJECT_USER_ROLES.MANAGER
      ]
    };
  } else {
    targetPanelData = {
      title: "ورود به پنل تنخواه‌داری",
      accesses: [PROJECT_USER_ROLES.CUSTODIAN]
    };
  }
  return targetPanelData;
};
